const state = {
  title: '',
  showHeader: true
}
const mutations = {
  'UPDATE_TITLE' (state, title) {
    state.title = title
    document.title = title
  },
  'UPDATE_TITLE_SHOW' (state, showHeader) {
    state.showHeader = showHeader
  }
}
export default {
  state,
  mutations
}